export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface ComicReview {
  id: string;
  userName: string;
  userLevel: string;
  avatarUrl: string;
  content: string;
  date: string;
  rating: number;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  description: string;
  longDescription: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  chapters: ComicChapter[];
  reviews: ComicReview[];
  isHot: boolean;
  isNew: boolean;
  isFree: boolean;
  updateDate: string;
}

export const categories = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事，感受心动瞬间' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '穿越异世界，开启奇幻冒险之旅' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', description: '热血战斗，紧张刺激的动作场面' },
  { name: '耽美', slug: 'bl', icon: 'ri-user-heart-line', description: '唯美动人的BL故事，心动不已' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常，让你笑到停不下来' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑故事，反转不断' },
  { name: '都市', slug: 'urban', icon: 'ri-building-line', description: '现代都市背景下的精彩人生故事' },
  { name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line', description: '唯美古风，穿越时空的传奇故事' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'boss-is-too-arrogant',
    title: '霸道总裁太嚣张',
    author: '韩智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20handsome%20CEO%20in%20a%20black%20suit%20with%20a%20confident%20expression%2C%20soft%20romantic%20lighting%2C%20clean%20cream%20background%2C%20modern%20digital%20art%20style%20with%20delicate%20linework%2C%20warm%20tone%2C%20romance%20genre&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '都市', '总裁'],
    description: '普通上班族林小柔意外成为霸道总裁的私人助理，两人在日常相处中逐渐产生情愫。',
    longDescription: '平凡的女孩林小柔从未想过自己会与高高在上的霸道总裁有任何交集。一次偶然的机会，她成为了总裁陆景琛的私人助理。面对这位冷漠又挑剔的上司，林小柔每天都在崩溃的边缘徘徊。然而，在朝夕相处中，她渐渐发现陆景琛冰冷外表下隐藏的温柔。两人的关系也在一次次意外中悄然改变...',
    status: '连载中',
    rating: 9.6,
    views: 12800000,
    favorites: 890000,
    chapters: [
      { id: 'c1-1', title: '第1话 意外的相遇', number: 1, updateDate: '2026-01-15' },
      { id: 'c1-2', title: '第2话 总裁的考验', number: 2, updateDate: '2026-01-22' },
      { id: 'c1-3', title: '第3话 心动瞬间', number: 3, updateDate: '2026-01-29' },
      { id: 'c1-128', title: '第128话 告白', number: 128, updateDate: '2026-07-06' },
      { id: 'c1-127', title: '第127话 危机', number: 127, updateDate: '2026-07-05' },
      { id: 'c1-126', title: '第126话 抉择', number: 126, updateDate: '2026-07-04' },
    ],
    reviews: [
      { id: 'r1', userName: '漫画迷小仙女', userLevel: '资深读者', avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20soft%20pastel%20background%2C%20chibi%20style%2C%20clean%20and%20simple&width=120&height=120&seq=avatar-user-01&orientation=squarish', content: '这部漫画真的太好看了！画风精美，剧情紧凑不拖沓，男女主的人设都很讨喜。每周都等着更新，完全停不下来！', date: '2026-07-05', rating: 5 },
      { id: 'r2', userName: '韩漫爱好者', userLevel: '黄金会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20with%20dark%20hair%20and%20glasses%2C%20simple%20minimal%20background%2C%20chibi%20style%2C%20clean%20design&width=120&height=120&seq=avatar-user-02&orientation=squarish', content: '霸道总裁系列的巅峰之作！陆总真的太帅了，每个表情都画得特别到位。强烈推荐给喜欢恋爱漫画的朋友！', date: '2026-07-03', rating: 5 },
    ],
    isHot: true,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-06',
  },
  {
    id: '2',
    slug: 'solo-leveling-remake',
    title: '我独自升级：重制版',
    author: '张成浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20with%20a%20powerful%20hunter%20holding%20a%20glowing%20sword%2C%20dark%20purple%20and%20black%20tone%2C%20epic%20atmosphere%2C%20dramatic%20lighting%2C%20digital%20art%2C%20fantasy%20genre&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '动作', '升级'],
    description: '世界突然出现了连接异次元的"门"，觉醒者们为了守护世界而战斗。最弱猎人程肖宇在一次生死危机中获得了神秘系统的力量。',
    longDescription: '十年前，世界突然出现了连接异次元的"门"。随之诞生的，是拥有超能力的"觉醒者"们。程肖宇，被称为"人类最弱兵器"的E级猎人，在一次几乎团灭的双重 dungeon 探险中，濒死之际获得了神秘的系统——"玩家系统"。从此，他成为了唯一能够"升级"的猎人，踏上了从最弱到最强的逆袭之路。',
    status: '连载中',
    rating: 9.8,
    views: 35600000,
    favorites: 2100000,
    chapters: [
      { id: 'c2-1', title: '第1话 E级猎人', number: 1, updateDate: '2026-02-01' },
      { id: 'c2-200', title: '第200话 最终决战', number: 200, updateDate: '2026-07-06' },
      { id: 'c2-199', title: '第199话 觉醒', number: 199, updateDate: '2026-07-05' },
      { id: 'c2-198', title: '第198话 援军', number: 198, updateDate: '2026-07-04' },
    ],
    reviews: [
      { id: 'r3', userName: '热血少年', userLevel: '白金会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20spiky%20red%20hair%2C%20fierce%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-03&orientation=squarish', content: '这就是我心中的神作！打斗场面的分镜简直无敌，每次看都热血沸腾。程肖宇的成长历程太燃了！', date: '2026-07-06', rating: 5 },
    ],
    isHot: true,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-06',
  },
  {
    id: '3',
    slug: 'goddess-advent',
    title: '女神降临',
    author: '猫咪',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20featuring%20a%20gorgeous%20girl%20with%20long%20brown%20hair%20and%20perfect%20makeup%2C%20transformation%20theme%2C%20soft%20warm%20lighting%2C%20school%20setting%20vibe%2C%20romantic%20atmosphere%2C%20delicate%20art%20style&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '校园', '化妆'],
    description: '因为外貌被欺负的女孩通过化妆变身为校园女神，却因此陷入了甜蜜的三角恋之中。',
    longDescription: '任朱静从小因为外貌被同学欺负，在转学后她决定通过学习化妆来改变自己。神奇的是，化妆后的她竟然变成了校园里的"女神"！在新学校，她遇到了冷酷帅气的李修豪和阳光温暖的书俊，展开了一段令人心动的校园恋爱故事。然而，素颜的秘密能藏多久呢？',
    status: '已完结',
    rating: 9.5,
    views: 42000000,
    favorites: 3200000,
    chapters: [
      { id: 'c3-1', title: '第1话 转学生', number: 1, updateDate: '2025-03-01' },
      { id: 'c3-250', title: '第250话 永远的约定（完结）', number: 250, updateDate: '2026-06-30' },
    ],
    reviews: [
      { id: 'r4', userName: '化妆小白', userLevel: '资深读者', avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20blonde%20hair%20and%20a%20gentle%20smile%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-04&orientation=squarish', content: '完结撒花！追了两年的漫画终于完结了，结局太完美了。感谢猫咪老师带给我们这么美好的故事！', date: '2026-07-01', rating: 5 },
    ],
    isHot: false,
    isNew: false,
    isFree: true,
    updateDate: '2026-06-30',
  },
  {
    id: '4',
    slug: 'heaven-official-blessing-kr',
    title: '天官赐福·韩版',
    author: '星光社',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20fantasy%20manhwa%20cover%20with%20flowing%20traditional%20Chinese-inspired%20robes%20in%20white%20and%20red%2C%20elegant%20ancient%20palace%20background%2C%20ethereal%20atmosphere%2C%20soft%20golden%20lighting%2C%20romantic%20and%20mystical%20vibe&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    tags: ['古风', '耽美', '仙侠'],
    description: '八百年前谢怜被贬下凡间，与绝境中相遇的花城展开了一段跨越时空的仙侠奇缘。',
    longDescription: '仙乐国太子谢怜，在第三次飞升时不小心破坏了天界的神官们的灵文殿，导致他欠下了八百八十八万功德债。为了还债，他不得不下凡完成任务。在凡间，他遇到了神秘的红衣少年花城，两人结伴同行，共同解决各种离奇事件。随着冒险的深入，谢怜发现花城与八百年前的一段往事有着千丝万缕的联系...',
    status: '连载中',
    rating: 9.7,
    views: 28900000,
    favorites: 1800000,
    chapters: [
      { id: 'c4-1', title: '第1话 第三次飞升', number: 1, updateDate: '2025-06-01' },
      { id: 'c4-156', title: '第156话 真相浮现', number: 156, updateDate: '2026-07-06' },
    ],
    reviews: [
      { id: 'r5', userName: '古风控', userLevel: '钻石会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20style%20girl%20avatar%20with%20long%20black%20hair%20and%20traditional%20hairpin%2C%20soft%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-05&orientation=squarish', content: '画风太绝美了！每一页都像艺术品一样精致。花城和谢怜的互动太甜了，看得我姨母笑停不下来！', date: '2026-07-04', rating: 5 },
    ],
    isHot: true,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-06',
  },
  {
    id: '5',
    slug: 'tower-of-god-season3',
    title: '神之塔 第三季',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20tall%20mystical%20tower%20reaching%20into%20the%20sky%2C%20various%20characters%20climbing%2C%20dark%20blue%20and%20golden%20color%20scheme%2C%20epic%20scale%2C%20adventure%20genre&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '冒险', '战斗'],
    description: '为了追寻唯一的挚友蕾哈尔，二十五夜独自进入了神秘的神之塔，踏上了一场改变命运的冒险之旅。',
    longDescription: '神之塔——一个能够实现任何愿望的地方。少年二十五夜为了追寻他生命中唯一的光——蕾哈尔，打开了塔的大门。然而，塔内的世界远比想象中更加残酷和复杂。每一层都有不同的考验和敌人，二十五夜必须不断变强，才能在这座塔中生存下去并找到蕾哈尔。第三季的故事将揭示更多关于塔的秘密和二十五夜的身世之谜。',
    status: '连载中',
    rating: 9.4,
    views: 19500000,
    favorites: 980000,
    chapters: [
      { id: 'c5-1', title: '第1话 塔之门', number: 1, updateDate: '2024-01-01' },
      { id: 'c5-580', title: '第580话 新世界', number: 580, updateDate: '2026-07-06' },
    ],
    reviews: [
      { id: 'r6', userName: '塔学家', userLevel: '资深读者', avatarUrl: 'https://readdy.ai/api/search-image?query=Smart%20anime%20boy%20avatar%20with%20blue%20hair%20and%20round%20glasses%2C%20thoughtful%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-06&orientation=squarish', content: 'SIU老师的世界观构建能力太强了！神之塔的世界层层递进，每次以为理解了又会有新的惊喜。期待第三季的展开！', date: '2026-07-05', rating: 5 },
    ],
    isHot: false,
    isNew: true,
    isFree: true,
    updateDate: '2026-07-06',
  },
  {
    id: '6',
    slug: 'office-romance-secret',
    title: '办公室恋情密事',
    author: '朴敏英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20office%20romance%20Korean%20manhwa%20cover%20with%20a%20handsome%20man%20and%20beautiful%20woman%20in%20business%20attire%20sharing%20a%20secret%20glance%2C%20office%20background%2C%20warm%20romantic%20lighting%2C%20adult%20romance%20genre%2C%20clean%20digital%20art&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '恋爱', '职场'],
    description: '同公司的两个人在办公室开始了秘密恋爱，在职场规则与感情之间寻找平衡。',
    longDescription: '广告公司的王牌策划金泰妍和设计总监南俊昊，在一次深夜加班中意外擦出火花。公司规定禁止办公室恋情，两人不得不小心翼翼地隐藏着这段秘密关系。白天是专业的同事关系，晚上却变成了甜蜜恋人。然而，随着感情的深入和职场的竞争，他们的秘密还能维持多久？',
    status: '连载中',
    rating: 9.3,
    views: 8900000,
    favorites: 560000,
    chapters: [
      { id: 'c6-1', title: '第1话 加班之夜', number: 1, updateDate: '2026-03-15' },
      { id: 'c6-78', title: '第78话 危机', number: 78, updateDate: '2026-07-05' },
    ],
    reviews: [
      { id: 'r7', userName: '职场人', userLevel: '白银会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20anime%20style%20woman%20avatar%20with%20short%20brown%20hair%20and%20confident%20smile%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-07&orientation=squarish', content: '太真实了！办公室恋情的紧张感和甜蜜感都刻画得很到位。金泰妍和南俊昊太配了！', date: '2026-07-04', rating: 4 },
    ],
    isHot: false,
    isNew: true,
    isFree: true,
    updateDate: '2026-07-05',
  },
  {
    id: '7',
    slug: 'dungeon-reset',
    title: '地下城重置',
    author: '金东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20dungeon-themed%20Korean%20manhwa%20cover%20with%20a%20lone%20warrior%20standing%20in%20front%20of%20a%20glowing%20portal%2C%20ancient%20ruins%20background%2C%20mysterious%20atmosphere%2C%20action%20fantasy%20genre%2C%20dramatic%20lighting&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '奇幻', '游戏'],
    description: '游戏设计师穿越到自己创造的游戏世界，却发现所有设定都被重置，他必须在这个危险的世界中生存下去。',
    longDescription: '顶级游戏设计师姜宇镇在一次意外中穿越到了自己设计的游戏世界。然而，他发现自己精心设计的游戏系统被完全重置了！原本安排好的所有"金手指"和隐藏福利统统消失，他变成了这个世界上最弱的角色。更糟糕的是，这个世界中的NPC似乎都拥有了自我意识，而他这个"造物主"成了所有人的目标。为了活下去，他必须利用自己对游戏底层代码的理解，在这个混乱的世界中找到生存之道。',
    status: '连载中',
    rating: 9.2,
    views: 11200000,
    favorites: 670000,
    chapters: [
      { id: 'c7-1', title: '第1话 穿越', number: 1, updateDate: '2026-02-20' },
      { id: 'c7-95', title: '第95话 真相', number: 95, updateDate: '2026-07-05' },
    ],
    reviews: [
      { id: 'r8', userName: '游戏宅', userLevel: '黄金会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Gamer%20anime%20boy%20avatar%20with%20headphones%20and%20hoodie%2C%20cool%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-08&orientation=squarish', content: '作为游戏玩家看这部漫画简直太爽了！各种游戏机制的设计很巧妙，剧情也很紧凑，推荐！', date: '2026-07-06', rating: 4 },
    ],
    isHot: false,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-05',
  },
  {
    id: '8',
    slug: 'funny-school-life',
    title: '爆笑学园日常',
    author: '李多惠',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20colorful%20and%20funny%20school%20comedy%20Korean%20manhwa%20cover%20with%20a%20group%20of%20exaggerated%20cartoonish%20students%20making%20silly%20faces%2C%20bright%20yellow%20and%20pink%20color%20scheme%2C%20comedy%20genre%2C%20energetic%20vibe&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '校园', '日常'],
    description: '一群性格各异的高中生在校园里发生的各种爆笑日常，让你笑出腹肌！',
    longDescription: '明成高中2年3班——全校出了名的问题班级。这里有整天做白日梦的中二病少年金在民，有表面高冷实则社恐的学霸李智恩，有运动神经超群但智商堪忧的体育生朴灿烈，还有暗中操控一切的腹黑班长崔秀雅。这群奇葩凑在一起，每一天都是一场灾难级别的爆笑喜剧。如果你需要解压，那就来看看这群活宝的日常吧！',
    status: '连载中',
    rating: 9.1,
    views: 15600000,
    favorites: 890000,
    chapters: [
      { id: 'c8-1', title: '第1话 开学第一天', number: 1, updateDate: '2025-09-01' },
      { id: 'c8-210', title: '第210话 修学旅行（下）', number: 210, updateDate: '2026-07-04' },
    ],
    reviews: [
      { id: 'r9', userName: '快乐源泉', userLevel: '资深读者', avatarUrl: 'https://readdy.ai/api/search-image?query=Happy%20anime%20girl%20avatar%20with%20twin%20tails%20and%20big%20smile%2C%20bright%20colors%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-09&orientation=squarish', content: '哈哈哈哈每话都笑到肚子疼！这班学生太有才了，崔班长简直是隐藏BOSS！强烈推荐！', date: '2026-07-04', rating: 5 },
    ],
    isHot: false,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-04',
  },
  {
    id: '9',
    slug: 'midnight-detective',
    title: '午夜侦探社',
    author: '崔明秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20Korean%20manhwa%20cover%20with%20a%20detective%20in%20a%20trench%20coat%20standing%20under%20a%20streetlamp%20at%20night%2C%20dark%20alley%20background%2C%20noir%20atmosphere%2C%20suspense%20genre%2C%20dramatic%20shadows&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '推理', '都市'],
    description: '只在午夜营业的神秘侦探社，专门解决警方无法处理的超自然案件。',
    longDescription: '午夜十二点，城市最阴暗的角落有一间只在这个时间开门的侦探社。社长韩智勋曾经是一名出色的刑警，因为一桩离奇的案件离开了警队。他和拥有特殊能力的助手们一起，接下了各种匪夷所思的案件——消失的尸体、预言死亡的画作、镜子里的另一个世界...每一个案件的背后，都隐藏着令人脊背发凉的真相。',
    status: '连载中',
    rating: 9.5,
    views: 7800000,
    favorites: 450000,
    chapters: [
      { id: 'c9-1', title: '第1话 午夜开门', number: 1, updateDate: '2026-04-01' },
      { id: 'c9-42', title: '第42话 镜中人', number: 42, updateDate: '2026-07-03' },
    ],
    reviews: [
      { id: 'r10', userName: '推理迷', userLevel: '白银会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Serious%20anime%20man%20avatar%20with%20detective%20hat%20and%20piercing%20eyes%2C%20mysterious%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-10&orientation=squarish', content: '氛围感拉满的悬疑漫画！每个案件都设计得很精巧，画风也非常适合悬疑题材。墙裂推荐！', date: '2026-07-05', rating: 5 },
    ],
    isHot: false,
    isNew: true,
    isFree: true,
    updateDate: '2026-07-03',
  },
  {
    id: '10',
    slug: 'bl-flower-shop',
    title: '花店老板的恋人',
    author: '尹智秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20BL%20romance%20Korean%20manhwa%20cover%20with%20two%20handsome%20men%20surrounded%20by%20colorful%20flowers%20in%20a%20flower%20shop%2C%20soft%20pastel%20color%20palette%2C%20romantic%20atmosphere%2C%20delicate%20art%20style&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    category: '耽美',
    categorySlug: 'bl',
    tags: ['耽美', '都市', '治愈'],
    description: '花店老板与咖啡师之间的温暖治愈故事，用花香与咖啡香编织出的浪漫恋爱。',
    longDescription: '在首尔一条安静的巷子里，有一家名为"春日"的花店。店主车恩宇是个温柔内向的年轻人，每天与花为伴。隔壁咖啡店的咖啡师郑在贤，性格开朗阳光，总是以各种理由来花店"串门"。一束花、一杯咖啡，两个年轻人在日常的点滴中，慢慢走近了彼此的内心。这是一部关于温暖、治愈和慢热爱情的BL故事。',
    status: '连载中',
    rating: 9.4,
    views: 6700000,
    favorites: 520000,
    chapters: [
      { id: 'c10-1', title: '第1话 隔壁的咖啡师', number: 1, updateDate: '2026-05-10' },
      { id: 'c10-35', title: '第35话 告白', number: 35, updateDate: '2026-07-06' },
    ],
    reviews: [
      { id: 'r11', userName: 'BL爱好者', userLevel: '钻石会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Soft%20anime%20girl%20avatar%20with%20wavy%20pastel%20hair%20and%20sparkly%20eyes%2C%20dreamy%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-11&orientation=squarish', content: '太甜了太甜了！这种慢热的感情线真的戳中我的心。车恩宇太可爱了，郑在贤太会撩了！', date: '2026-07-06', rating: 5 },
    ],
    isHot: false,
    isNew: true,
    isFree: true,
    updateDate: '2026-07-06',
  },
  {
    id: '11',
    slug: 'return-of-legend',
    title: '传奇归来',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20warrior%20returning%20from%20another%20world%20in%20a%20Korean%20manhwa%20cover%2C%20ancient%20armor%20and%20modern%20city%20contrast%2C%20epic%20fantasy%20action%20genre%2C%20dramatic%20lighting%2C%20dynamic%20composition&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '动作', '回归'],
    description: '异世界的最强战士回归地球，却发现地球也面临着前所未有的危机。',
    longDescription: '被称为"异世界的英雄"的金泰浩，在拯救了异世界之后终于回到了地球。然而，迎接他的不是平静的日常生活，而是突然出现的怪物和觉醒者。地球竟然也开始"异世界化"了！曾经在异世界呼风唤雨的最强战士，在地球上却要重新开始。他能否再次成为传奇，保护这个他深爱的世界？',
    status: '连载中',
    rating: 9.3,
    views: 13400000,
    favorites: 760000,
    chapters: [
      { id: 'c11-1', title: '第1话 归来', number: 1, updateDate: '2026-03-01' },
      { id: 'c11-88', title: '第88话 宣战', number: 88, updateDate: '2026-07-06' },
    ],
    reviews: [
      { id: 'r12', userName: '奇幻爱好者', userLevel: '黄金会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Cool%20anime%20knight%20avatar%20with%20silver%20armor%2C%20determined%20expression%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-12&orientation=squarish', content: '回归类漫画中的精品！战斗场景画得太好了，剧情节奏也很舒服。期待后续发展！', date: '2026-07-06', rating: 4 },
    ],
    isHot: true,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-06',
  },
  {
    id: '12',
    slug: 'historical-princess',
    title: '公主的逆袭',
    author: '韩艺瑟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20historical%20Korean%20manhwa%20cover%20with%20a%20princess%20in%20elegant%20traditional%20hanbok%20standing%20in%20a%20palace%20garden%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20golden%20light%2C%20romantic%20historical%20genre&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    tags: ['古风', '宫廷', '逆袭'],
    description: '被陷害致死的公主重生回到十年前，这一次她要改写自己的命运。',
    longDescription: '朝鲜王朝最受宠爱的明惠公主，在大婚当日被最信任的侍女和未婚夫联手陷害，含冤而死。然而，当她再次睁开眼睛，发现自己竟然回到了十年前，一切悲剧尚未发生的时候。带着前世的记忆，这一次她不会再做任人摆布的棋子。她要找出幕后黑手，保护真正爱她的人，拿回属于自己的一切！',
    status: '连载中',
    rating: 9.6,
    views: 20100000,
    favorites: 1450000,
    chapters: [
      { id: 'c12-1', title: '第1话 重生', number: 1, updateDate: '2025-11-01' },
      { id: 'c12-120', title: '第120话 真相', number: 120, updateDate: '2026-07-05' },
    ],
    reviews: [
      { id: 'r13', userName: '古风迷', userLevel: '白金会员', avatarUrl: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20princess%20avatar%20with%20traditional%20hair%20ornament%20and%20graceful%20smile%2C%20historical%20style%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-user-13&orientation=squarish', content: '重生复仇的剧情太上头了！公主这个角色的成长弧线写得太好了，从天真到成熟，看得我热泪盈眶！', date: '2026-07-05', rating: 5 },
    ],
    isHot: false,
    isNew: false,
    isFree: true,
    updateDate: '2026-07-05',
  },
];